// removed by extract-text-webpack-plugin
module.exports = {"vpModalContainer":"vpModalContainer___1mFiu","vpModalWarning":"vpModalWarning___1sfmk","vpModalActions":"vpModalActions___3VBPi","vpModalIcon":"vpModalIcon___2dDJ_","vpModalDeleteButton":"vpModalDeleteButton___1kbfh"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/widgets/VpMediaTable/VpDeleteModal.module.less
// module id = 3433
// module chunks = 33